import { render, staticRenderFns } from "./AllocationWeight.vue?vue&type=template&id=1ef6cec9"
import script from "./AllocationWeight.vue?vue&type=script&lang=js"
export * from "./AllocationWeight.vue?vue&type=script&lang=js"
import style0 from "./AllocationWeight.vue?vue&type=style&index=0&id=1ef6cec9&prod&style=scss&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports